import styled from 'styled-components';
import { Icon } from 'lego-dist';

export const DescriptionWrapper = styled.div`
  border: 1.5px solid #acc2d3;
  margin-bottom: 20px;
  border-radius: 8px;
`;

export const DescriptionHeader = styled.div`
  display: flex;
  padding: 10px 20px;
  padding-bottom: ${(props) => (props.showBorder ? '10px' : '0px')};
  border-bottom: ${(props) => (props.showBorder ? '1px solid #ACC2D3' : '')};
  img {
    margin-right: 5px;
  }
`;

export const DescriptionContent = styled.div`
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 15px;
  padding-top: 15px;
  max-height: 104px;
  overflow: auto;
  /* FIREFOX */
  scrollbar-color: #acc2d3 #ed005e1a;
  scrollbar-width: thin;
  /* CHROME */
  &::-webkit-scrollbar {
    width: 7px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #fff;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #acc2d3;
    border-radius: 10px;
  }
`;

export const Content = styled.p`
  display: flex;
  align-items: center;
  font-weight: 300;
  margin: 0px;
  font-size: 16px;
  span {
    color: #657480;
  }
  &::first-letter {
    text-transform: capitalize;
  }
  word-break: break-all;
  white-space: normal;

  a {
    text-decoration: underline;
    color: #1faddf;
    &:hover {
      text-decoration: none;
    }
  }
`;

export const DescriptionTitle = styled.p`
  display: flex;
  align-items: center;
  font-weight: 300;
  margin: 0px;
  font-size: 14px;
  color: #404040;
  span {
    color: #404040;
  }
  &::first-letter {
    text-transform: capitalize;
  }
  font-weight: bolder;
`;

export const LinkMeeting = styled.a`
  text-decoration: underline;
  color: #1faddf;
  word-break: break-all;
  line-height: 19px;
`;

export const DescriptionEvent = styled.div`
  margin-top: 20px;
`;

export const DateDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  ${({ theme }) => theme.breakPoints.desktop} {
    flex-direction: row;
  }
`;

export const DateWrapper = styled.div`
  border-left: 1.5px solid #acc2d3;
  border-top: 1.5px solid #acc2d3;
  border-bottom: 1.5px solid #acc2d3;
  border-right: 1.5px solid #acc2d3;
  margin-bottom: 20px;
  padding: 10px 20px;
  border-radius: 8px;
  ${({ theme }) => theme.breakPoints.desktop} {
    width: 50%;
    margin-bottom: 0px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-right: 0;
  }
`;

export const Footer = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const DateContainer = styled.div`
  display: flex;
  margin-top: 15px;
  align-items: center;
  img {
    margin-right: 5px;
  }
`;

export const IconWrapper = styled.div`
  padding-right: 18px;
`;

export const EventIcon = styled(Icon)`
  stroke: none;
`;

export const HourWrapper = styled.div`
  border: 1.5px solid #acc2d3;
  padding: 10px 20px;
  border-radius: 8px;
  ${({ theme }) => theme.breakPoints.desktop} {
    width: 50%;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`;

export const Capitalize = styled.span`
  text-transform: capitalize;
`;

export const ImageWrapper = styled.div`
  background-color: #cfd5da;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  text-align: center;
  margin-right: 10px;
  flex-shrink: 0;
`;

export const AvatarImage = styled.img`
  position: relative;
  top: 5px;
  width: ${(props) => (props.imageType === 'student' ? '31px' : '25px')};
  height: ${(props) => (props.imageType === 'student' ? '52px' : '25px')};
`;

export const ParticipantWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  max-height: 104px;
  overflow: auto;
  padding-top: 15px;

  /* FIREFOX */
  scrollbar-color: #acc2d3 #ed005e1a;
  scrollbar-width: thin;
  /* CHROME */
  &::-webkit-scrollbar {
    width: 7px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #fff;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #acc2d3;
    border-radius: 10px;
  }
`;

export const ParticipantContent = styled.div`
  display: flex;
  margin-bottom: 18px;
  margin-right: 15px;
  width: 100%;
  ${({ theme }) => theme.breakPoints.tablet} {
    width: calc(33.3% - 15px);
  }
`;

export const DescriptionText = styled.p`
  font-weight: 300;
  margin: 0px;
  font-size: 16px;
  height: 100%;
  span {
    color: #657480;
  }
  &::first-letter {
    text-transform: capitalize;
  }
  word-break: break-all;
  white-space: normal;

  a {
    text-decoration: underline;
    color: #1faddf;
    &:hover {
      text-decoration: none;
    }
  }
`;

export const SelectedUsers = styled.div`
  border: 1.5px solid #bbbdbf;
  margin-top: 20px;
  border-radius: 8px;
  ${({ theme }) => theme?.lego?.BodyModal?.SelectedUsers}
`;

export const TitleDescription = styled.div`
  border-bottom: 1.5px solid #bbbdbf;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme?.lego?.BodyModal?.TitleDescription}
`;

export const TotalParticipes = styled.p`
  font-weight: normal;
  color: darkgrey;
  font-size: 12px;
  margin: 0px;
  ${({ theme }) => theme?.lego?.BodyModal?.TotalParticipes}
`;

export const ListWrapper = styled.div`
  display: flex;
  padding: 10px;
  flex-wrap: wrap;
  max-height: 232px;
  overflow-y: auto;
  /* FIREFOX */
  scrollbar-color: #f0005c #ed005e1a;
  scrollbar-width: thin;
  /* CHROME */
  &::-webkit-scrollbar {
    width: 7px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #ed005e1a;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #f0005c;
    border-radius: 10px;
  }
  ${({ theme }) => theme?.lego?.BodyModal?.ListWrapper}
`;

export const TagSeparator = styled.div`
  padding: 5px;
  ${({ theme }) => theme?.lego?.BodyModal?.TagSeparator}
`;

export const DotSeparator = styled.div`
  width: 30px;
  text-align: center;
`;

export const DashSeparator = styled.div`
  width: 15px;
  text-align: center;
`;
